module.exports = __webpack_public_path__ + "img/no_order.05cadc9d.svg";